__turbopack_context__.v({
  "ClearAllFilters": "IG6Lzq_ClearAllFilters",
  "CompanyItem": "IG6Lzq_CompanyItem",
  "CompanyItem--Disabled": "IG6Lzq_CompanyItem--Disabled",
  "CompanyList": "IG6Lzq_CompanyList",
  "CompanySelectorArrowIcon": "IG6Lzq_CompanySelectorArrowIcon",
  "CompanySelectorButton": "IG6Lzq_CompanySelectorButton",
  "CompanySelectorIcon": "IG6Lzq_CompanySelectorIcon",
  "CompanySelectorText": "IG6Lzq_CompanySelectorText",
  "Disabled": "IG6Lzq_Disabled",
  "Filter": "IG6Lzq_Filter",
  "FilterButton": "IG6Lzq_FilterButton",
  "FilterIcon": "IG6Lzq_FilterIcon",
  "NoResults": "IG6Lzq_NoResults",
  "Open": "IG6Lzq_Open",
  "SearchIcon": "IG6Lzq_SearchIcon",
  "SearchInput": "IG6Lzq_SearchInput",
  "SearchInputContainer": "IG6Lzq_SearchInputContainer",
  "skeleton-loading": "IG6Lzq_skeleton-loading",
});
